module.exports = __webpack_public_path__ + "static/media/failure-consents-illus.7a184b38.png";